"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Link/lib/Link.js",
  _templateObject,
  _this = void 0;
function cov_yggw55mnp() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Link/lib/Link.js";
  var hash = "22015279913d0a6dc150382ebcc013f0d20b9672";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/Link/lib/Link.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 15
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 28
        },
        end: {
          line: 9,
          column: 42
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 98
        }
      },
      "3": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 23,
          column: 37
        }
      },
      "4": {
        start: {
          line: 34,
          column: 13
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "5": {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 35,
          column: 29
        }
      },
      "6": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      },
      "7": {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "8": {
        start: {
          line: 49,
          column: 0
        },
        end: {
          line: 51,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 19
          },
          end: {
            line: 9,
            column: 20
          }
        },
        loc: {
          start: {
            line: 9,
            column: 28
          },
          end: {
            line: 9,
            column: 42
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 11
          },
          end: {
            line: 12,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 13,
            column: 98
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 13
          },
          end: {
            line: 21,
            column: 14
          }
        },
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 23,
            column: 37
          }
        },
        line: 22
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 34,
            column: 13
          },
          end: {
            line: 34,
            column: 14
          }
        },
        loc: {
          start: {
            line: 34,
            column: 22
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 13,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 5
          },
          end: {
            line: 13,
            column: 16
          }
        }, {
          start: {
            line: 13,
            column: 20
          },
          end: {
            line: 13,
            column: 36
          }
        }, {
          start: {
            line: 13,
            column: 40
          },
          end: {
            line: 13,
            column: 62
          }
        }, {
          start: {
            line: 13,
            column: 67
          },
          end: {
            line: 13,
            column: 98
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 23,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 7
          },
          end: {
            line: 22,
            column: 18
          }
        }, {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 38
          }
        }, {
          start: {
            line: 22,
            column: 42
          },
          end: {
            line: 22,
            column: 64
          }
        }, {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 23,
            column: 37
          }
        }],
        line: 22
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "22015279913d0a6dc150382ebcc013f0d20b9672"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_yggw55mnp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_yggw55mnp();
var MyLink = (cov_yggw55mnp().s[0]++, _styledComponents.default.a.attrs({
  className: 'g-Link',
  'aria-disabled': function ariaDisabled(props) {
    cov_yggw55mnp().f[0]++;
    cov_yggw55mnp().s[1]++;
    return props.disabled;
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-decoration: none;\n  color: ", ";\n  font-size: inherit;\n  cursor: pointer;\n\n  &:focus,\n  &:active,\n  &:hover {\n    outline-offset: 1px;\n    color: ", ";\n  }\n"])), function (props) {
  cov_yggw55mnp().f[1]++;
  cov_yggw55mnp().s[2]++;
  return (cov_yggw55mnp().b[0][0]++, props.theme) && (cov_yggw55mnp().b[0][1]++, props.theme.link) && (cov_yggw55mnp().b[0][2]++, props.theme.link.color) || (cov_yggw55mnp().b[0][3]++, _stylingConstants.default.color.baseText);
}, function (props) {
  cov_yggw55mnp().f[2]++;
  cov_yggw55mnp().s[3]++;
  return (cov_yggw55mnp().b[1][0]++, props.theme) && (cov_yggw55mnp().b[1][1]++, props.theme.link) && (cov_yggw55mnp().b[1][2]++, props.theme.link.color) || (cov_yggw55mnp().b[1][3]++, _stylingConstants.default.color.baseText);
}));

/** A simple component to show a link.
  Theming value :
    theme.link : {
    color
  }

*/
cov_yggw55mnp().s[4]++;
var Link = function Link(props) {
  cov_yggw55mnp().f[3]++;
  var _ref = (cov_yggw55mnp().s[5]++, props),
    customRef = _ref.customRef;
  cov_yggw55mnp().s[6]++;
  return /*#__PURE__*/_react.default.createElement(MyLink, (0, _extends2.default)({}, props, {
    innerRef: customRef,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }));
};
cov_yggw55mnp().s[7]++;
Link.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  customRef: _propTypes.default.any
};
cov_yggw55mnp().s[8]++;
Link.defaultProps = {
  customRef: null
};
var _default = exports.default = Link;